import { DatePipe } from '@angular/common';
import { FormatNumberPipe } from '../../../../../shared/pipes/number-separator.pipe';
import { EntityPopup, PopupInfoItem } from './entity-popup.interface';

export class HidrantePopup implements EntityPopup {
  private formatNumber = new FormatNumberPipe();
  private datePipe = new DatePipe('es-ES');

  constructor(
    private entity: any,
    private onVerParcelasClick?: () => void
  ) {}

  getBadgeText(): string {
    const battery = this.formatNumber.transform(this.entity.current_battery);
    return `Batería: ${battery} mV`;
  }

  getInfoItems(): PopupInfoItem[] {
    const formattedDate = this.datePipe.transform(
      this.entity.current_datetime,
      'dd/MM/yyyy HH:mm:ss'
    );

    const items: PopupInfoItem[] = [
      {
        icon: 'water',
        label: 'Caudal',
        value: this.entity.current_flow,
        unit: 'm³/h',
        date: formattedDate,
      },
      {
        icon: 'swap_driving_apps_wheel',
        label: 'Presión',
        value:
          this.entity.current_pressure != null
            ? this.entity.current_pressure.toFixed(2)
            : null,
        unit: 'bar',
        date: formattedDate,
      },
      {
        icon: 'readiness_score',
        label: 'Última lectura',
        value:
          this.entity.current_accumulated != null
            ? this.entity.current_accumulated.toFixed(2)
            : null,
        unit: 'm³',
        date: formattedDate,
      },
    ];

    if (this.onVerParcelasClick) {
      items.push({
        icon: 'pin_drop',
        label: 'Ver Parcelas asociadas',
        value: null,
        isClickable: true,
        clickAction: this.onVerParcelasClick,
      });
    }

    return items;
  }
}
